import { jsx as _jsx } from "react/jsx-runtime";
export const Button = ({ variant = "primary", size = "md", className = "", children, ...props }) => {
    const baseClasses = "touch-target transition-smooth rounded border font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
    const variantClasses = {
        primary: "bg-textPrimary text-background border-textPrimary hover:bg-textSecondary focus:ring-textPrimary",
        secondary: "bg-accent text-textPrimary border-accent hover:bg-textSecondary focus:ring-accent",
        outline: "bg-transparent text-textPrimary border-border hover:bg-surface focus:ring-textPrimary",
    };
    const sizeClasses = {
        sm: "px-3 py-1.5 text-sm",
        md: "px-4 py-2 text-base",
        lg: "px-6 py-3 text-lg",
    };
    const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
    return (_jsx("button", { className: classes, ...props, children: children }));
};
